/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Link_Expired_TitleInputs */

const en_password_reset_link_expired_title = /** @type {(inputs: Password_Reset_Link_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has expired`)
};

const es_password_reset_link_expired_title = /** @type {(inputs: Password_Reset_Link_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este enlace ha caducado`)
};

/**
* | output |
* | --- |
* | "This link has expired" |
*
* @param {Password_Reset_Link_Expired_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_link_expired_title = /** @type {((inputs?: Password_Reset_Link_Expired_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Link_Expired_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_link_expired_title(inputs)
	return en_password_reset_link_expired_title(inputs)
});